module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-home-tiles"
  }, [_c('div', {
    staticClass: "tab-home-tiles__container"
  }, [_c('div', {
    staticClass: "tab-home-tiles__row"
  }, _vm._l((_vm.props.tiles), function(tile, i) {
    return _c('router-link', {
      key: i,
      staticClass: "tab-home-tiles__tile",
      attrs: {
        "to": tile.method
      }
    }, [_c('div', {
      staticClass: "tab-home-tiles__tile-background",
      style: ("backgroundImage: url(" + tile.image + ");")
    }), _c('div', {
      staticClass: "tab-home-tiles__tile-overlay"
    }, [_c('div', {
      staticClass: "tab-home-tiles__tile-rectangle"
    }), _c('div', {
      staticClass: "tab-home-tiles__tile-arrow"
    }, [_c('Icon', {
      attrs: {
        "name": "RightArrow"
      }
    })], 1), _c('div', {
      staticClass: "tab-home-tiles__tile-text",
      domProps: {
        "innerHTML": _vm._s(tile.text)
      }
    }), _c('div', {
      staticClass: "tab-home-tiles__tile-text-alt"
    }, [_vm._v("Learn More")])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f5546e3","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tab/tab-home-tiles/tab-home-tiles.pug
// module id = 623
// module chunks = 1